export const audienceTags = new Set([
	'family',
	'family_life',
	'family_outing',
	'family_values',
	'family_gatherings',
	'kids',
	'pre_teens',
	'teens',
	'toddlers',
	'preschoolers',
	'parents_and_children',
	'grandparent_and_grandchild',
	'child_care',
	'childhood',
	'mischievous_children',
	'animation',
	'educational',
	'puppets',
	'pets',
	'dog',
	'school',
	'elementary_school',
	'high_school',
	'boarding_school',
	'contests_and_competitions',
	'dance_school',
	'underdog',
	'action',
	'adventure',
	'thriller',
	'superhero',
	'fight_back',
	'fighting_crime',
	'martial_arts',
	'swordfight',
	'chase',
	'car_chase',
	'boat_chase',
	'chases_and_races',
	'heist',
	'escape',
	'survival',
	'rescue',
	'daring_rescue',
	'spy',
	'mercenary',
	'warrior',
	'master_warrior',
	'comedy',
	'comedy_of_errors',
	'parody',
	'satire',
	'slapstick',
	'screwball',
	'irreverent_humor',
	'silly_humor',
	'feel_good',
	'humorous',
	'witty',
	'tragicomedy',
	'mystery',
	'detective',
	'amateur_detective',
	'private_detective',
	'investigation',
	'investigative',
	'investigator',
	'crime',
	'crimes',
	'murderer',
	'police_detective',
	'police_investigation',
	'cop',
	'law_enforcer',
	'criminal_psychologist',
	'organized_crime',
	'perfect_crime',
	'witnessing_a_crime',
]);
